/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { next } from '@ember/runloop';
import moment from 'moment/moment';

export default class AssessmentRoute extends Route {
  queryParams = {
    asOnDate: {
      refreshModel: true,
      as: 'asOnDate',
    },
  };

  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');
    let asAtTime = isEmpty(params.asOnDate)
      ? undefined
      : moment(params.asOnDate).endOf('day').unix();
    return hash({
      assessment: store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      modules: store.query('assessments/module', {
        assessmentId: params.assessment_id,
      }),
      group,
      grades: store.query('assessments/grade', {
        assessmentId: params.assessment_id,
        groupId: group.id,
        latest: false,
        asAtTime,
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    this.controller.setProperties({
      autosaveNumericGrades: this.controller.get(
        'personOptions.autosaveNumericGrades',
      ),
      newAsOnDate: this.controller.asOnDate,
      newFromDate: this.controller.fromDate,
      selectedLearners: [],
      selectedLearnerObjects: [],
      bulkGrades: [],
      filteredModules: this.controller.get('assessment.sortedModules').slice(),
    });

    if (isEmpty(model.modules)) {
      return;
    }

    let auditReasons = this.controller.auditReason;
    model.modules.forEach((module) => {
      auditReasons[module.id] = '';
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
